// Generated by purs version 0.15.0
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
var AddToCart = /* #__PURE__ */ (function () {
    function AddToCart(value0) {
        this.value0 = value0;
    };
    AddToCart.create = function (value0) {
        return new AddToCart(value0);
    };
    return AddToCart;
})();
var LocateMe = /* #__PURE__ */ (function () {
    function LocateMe() {

    };
    LocateMe.value = new LocateMe();
    return LocateMe;
})();
var RemoveFromCart = /* #__PURE__ */ (function () {
    function RemoveFromCart(value0) {
        this.value0 = value0;
    };
    RemoveFromCart.create = function (value0) {
        return new RemoveFromCart(value0);
    };
    return RemoveFromCart;
})();
var BeginCheckout = /* #__PURE__ */ (function () {
    function BeginCheckout(value0) {
        this.value0 = value0;
    };
    BeginCheckout.create = function (value0) {
        return new BeginCheckout(value0);
    };
    return BeginCheckout;
})();
var Purchase = /* #__PURE__ */ (function () {
    function Purchase(value0) {
        this.value0 = value0;
    };
    Purchase.create = function (value0) {
        return new Purchase(value0);
    };
    return Purchase;
})();
var SetCheckoutOption = /* #__PURE__ */ (function () {
    function SetCheckoutOption(value0) {
        this.value0 = value0;
    };
    SetCheckoutOption.create = function (value0) {
        return new SetCheckoutOption(value0);
    };
    return SetCheckoutOption;
})();
var promotionalCategory = "Promotional";
var nonPromotionalCategory = "NonPromotional";
var genericEvent = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new AddToCart(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return LocateMe.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new RemoveFromCart(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new BeginCheckout(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new Purchase(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
            return new SetCheckoutOption(x.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Tracking.Event (line 42, column 1 - line 42, column 48): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AddToCart) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof LocateMe) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof RemoveFromCart) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof BeginCheckout) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof Purchase) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof SetCheckoutOption) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))));
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Tracking.Event (line 42, column 1 - line 42, column 48): " + [ x.constructor.name ]);
    }
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeForeignEvent = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericEvent)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AddToCart";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "category";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "LocateMe";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "RemoveFromCart";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "category";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "BeginCheckout";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(/* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "category";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Purchase";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "transactionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "total";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "shipping";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(/* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "category";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))))({
        reflectSymbol: function () {
            return "coupon";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "affiliation";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "SetCheckoutOption";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "selectedValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "selectedOption";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))))))))(encodingOpts)
};
var toPlatformEvent = function (v) {
    if (v instanceof AddToCart) {
        return {
            name: "AddToCart",
            value: Foreign_Generic_Class.encode(encodeForeignEvent)(v)
        };
    };
    if (v instanceof LocateMe) {
        return {
            name: "LocateMe",
            value: Foreign_Generic_Class.encode(encodeForeignEvent)(v)
        };
    };
    if (v instanceof RemoveFromCart) {
        return {
            name: "RemoveFromCart",
            value: Foreign_Generic_Class.encode(encodeForeignEvent)(v)
        };
    };
    if (v instanceof BeginCheckout) {
        return {
            name: "BeginCheckout",
            value: Foreign_Generic_Class.encode(encodeForeignEvent)(v)
        };
    };
    if (v instanceof Purchase) {
        return {
            name: "Purchase",
            value: Foreign_Generic_Class.encode(encodeForeignEvent)(v)
        };
    };
    if (v instanceof SetCheckoutOption) {
        return {
            name: "SetCheckoutOption",
            value: Foreign_Generic_Class.encode(encodeForeignEvent)(v)
        };
    };
    throw new Error("Failed pattern match at Restaumatic.Analytics.Tracking.Event (line 57, column 19 - line 63, column 76): " + [ v.constructor.name ]);
};
export {
    promotionalCategory,
    nonPromotionalCategory,
    AddToCart,
    LocateMe,
    RemoveFromCart,
    BeginCheckout,
    Purchase,
    SetCheckoutOption,
    encodingOpts,
    toPlatformEvent,
    genericEvent,
    encodeForeignEvent
};
//# sourceMappingURL=index.js.map
